const EMAIL_CACHE_KEY = 'rememberedEmail'
const EMAIL_PREFERENCE_KEY = 'rememberEmailPreference'

/**
 * Masks email characters between 3rd character and @ symbol
 * @param {string} email - The email to mask
 * @returns {string} The masked email
 */
export function maskEmail(email) {
  if (!email || !email.includes('@')) {
    return email
  }
  
  const [localPart, domain] = email.split('@')
  
  if (localPart.length <= 3) {
    return email // Don't mask if local part is 3 characters or less
  }
  
  const maskedLocalPart = localPart.substring(0, 3) + '*'.repeat(localPart.length - 3)
  return `${maskedLocalPart}@${domain}`
}

/**
 * Retrieves the saved email from localStorage
 * @returns {string|null} The saved email or null if not found
 */
export function getRememberedEmail() {
  return localStorage.getItem(EMAIL_CACHE_KEY)
}

/**
 * Checks if email should be remembered based on user preference
 * @returns {boolean} True if user wants to remember email
 */
export function shouldRememberEmail() {
  return localStorage.getItem(EMAIL_PREFERENCE_KEY) === 'true'
}

/**
 * Gets the initial email value for the form (masked if remembered)
 * @returns {string} The email to display in the input field
 */
export function getInitialEmail() {
  const remembered = shouldRememberEmail()
  const storedEmail = getRememberedEmail()
  return remembered && storedEmail ? maskEmail(storedEmail) : ''
}

/**
 * Clears the stored email and preference from localStorage
 */
export function clearEmailCache() {
  localStorage.removeItem(EMAIL_CACHE_KEY)
  localStorage.removeItem(EMAIL_PREFERENCE_KEY)
}

/**
 * Sets the email cache for the form submission
 * @param {string} loginEmail - The email from the form input
 * @returns {string} The email to actually submit for authentication
 */
export function setEmailCache(loginEmail) {
  localStorage.setItem(EMAIL_CACHE_KEY, loginEmail)
  localStorage.setItem(EMAIL_PREFERENCE_KEY, 'true')
}

/**
 * Gets the email to submit for authentication (handles masked email case)
 * @param {string} loginEmail - The email from the form input
 * @returns {string} The email to submit for authentication
 */
export function getEmailToSubmit(loginEmail) {
  const storedEmail = getRememberedEmail()
  if (storedEmail && loginEmail === maskEmail(storedEmail)) {
    return storedEmail
  }
  return loginEmail
}
